"use strict";

var _AsyncBoundary;
import { InputLoading } from '@autoguru/components';
import { StaticMFEShadowedComponent } from '@autoguru/static-mfe/static-mfe-shadowed-component';
import { AsyncBoundary } from '@autoguru/suspense';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalNotification = () => _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
  fallback: /*#__PURE__*/_jsx(InputLoading, {}),
  children: /*#__PURE__*/_jsx(StaticMFEShadowedComponent, {
    width: "full",
    mfeAppName: "sp-global-notification"
  })
}));